module.exports = "https://static.zego.com/_next/static/images/SwissRe-b1c3548e4f7f5d32cb2c0d35fd412959.svg";